module.exports = __webpack_public_path__ + "static/baashyaam_logo-d1005d88bee065ee771305d4da6d9226.png";